// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1938b636313807e91f7a7852591fe3ac8f43380f/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};